/**
 * Medical Picture
 *
 * Placeholder component for medical picture/overview.
 */

import { View } from "react-native";

export function MedicalPicture() {
  return <View />;
}
